import useTypedContext from "hooks/useTypedContext";

import StackSettingsFormWrapper from "../components/FormWrapper";
import StackSettingsPageLayout from "../components/PageLayout";
import StackSettingsBehaviorEdit from "./Edit";
import StackSettingsBehaviorView from "./View";
import { StackSettingsContextData } from "../Context";

const StackSettingsBehavior = () => {
  const { canUpdateStack } = useTypedContext(StackSettingsContextData);

  return (
    <StackSettingsPageLayout title="Behavior" description="Additional stack settings.">
      <StackSettingsFormWrapper>
        {canUpdateStack.result ? <StackSettingsBehaviorEdit /> : <StackSettingsBehaviorView />}
      </StackSettingsFormWrapper>
    </StackSettingsPageLayout>
  );
};

export default StackSettingsBehavior;
